import { Clock } from "lucide-react";

import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";

import { useBatchExpiry } from "../../hooks/useBatchExpiry";

export interface BatchExpiryBannerProps {
  expiresAt: string | null;
  /** Fired once when the clock hits zero; the caller re-reads and trusts the server's EXPIRED. */
  onExpire: () => void;
}

/** A reviewed batch has 24 h to be confirmed; this keeps that clock in view and turns amber for the last hour. */
export function BatchExpiryBanner({ expiresAt, onExpire }: BatchExpiryBannerProps) {
  const { t } = useTranslations("payoutBatches");
  const expiry = useBatchExpiry(expiresAt, onExpire);
  if (!expiresAt) return null;

  return (
    <ColocaAlert
      variant={expiry.isExpired || expiry.isClosing ? "warning" : "secondary"}
      icon={Clock}
      text={
        expiry.isExpired ? (
          t("expiry_expired")
        ) : (
          <span>
            {t("expiry_banner", { time: "" }).trim()}{" "}
            <span className="font-mono font-semibold tabular-nums">{expiry.formatted}</span>
          </span>
        )
      }
    />
  );
}
